<button mat-icon-button (click)="goBack()">
    <mat-icon>keyboard_backspace</mat-icon>
</button>